<template>
    <div>
        <v-row>
            <v-container fluid elevation-1>
                <v-row>
                    <v-col cols="2" span="2">
                        <!-- <v-icon color="success" large class="avatar-icon">mdi-numeric-4</v-icon><span
                            class="pl-4 font-weight-light"><i>Process price update</i></span> -->
                        <v-row class="pl-4 mt-4">
                            <v-col cols="10" span="10">
                                <v-select v-model="wizardData.filter" v-bind:items="stat_filter"
                                    prepend-icon="mdi-filter-outline" item-value="code" item-text="name" label="Status"
                                    dense></v-select>
                            </v-col>
                            <v-col cols="2" span="2" class="mt-3">
                                <div class="table-markup">({{ this.filteredPrices.length }})</div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4" span="4">
                        <v-card flat class="card-summary" v-if="this.wizardData.new_prices.length !== 0">
                            <v-row dense>
                                <v-col cols="2">Results: </v-col>
                                <v-col cols="10">
                                    <span><v-icon medium color="primary"
                                            class="mb-1">mdi-information-outline</v-icon></span>
                                    <span class="ml-2">{{ this.wizardData.updated }} price(s) updated</span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="2"></v-col>
                                <v-col cols="10">
                                    <span><v-icon medium color="error"
                                            class="mb-1">mdi-alert-octagon-outline</v-icon></span>
                                    <span class="ml-2">{{ this.wizardData.error }} price(s) have errors</span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="2"></v-col>
                                <v-col cols="10">
                                    <span><v-icon medium color="warning" class="mb-1">mdi-alert-outline</v-icon></span>
                                    <span class="ml-2">{{ this.wizardData.warning }} price(s) have warnings</span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="2"></v-col>
                                <v-col cols="10">
                                    <span><v-icon medium color="success" class="mb-1">mdi-check-bold</v-icon></span>
                                    <span class="ml-2">{{ this.wizardData.correct }} price(s) ready</span>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="6" span="6" align-self="stretch">
                        <span>
                            <v-card flat class="card-markup">
                                <v-row dense>
                                    <v-col cols="3">
                                        <span>Initially selected prices</span>
                                    </v-col>
                                    <v-col cols="1">
                                        <span>{{ this.number_hsnp_selected }}</span>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="3">
                                        <span>Selected for update</span>
                                    </v-col>
                                    <v-col cols="1">
                                        <span>{{ this.wizardData.toggled_prices.length }}</span>
                                    </v-col>
                                    <v-col cols="8" v-if="this.wizardData.toggled_prices.length === 0">
                                        <span><v-icon color="warning" class="mb-1">mdi-alert-outline</v-icon></span>
                                        <span class="ml-2">No prices selected for update</span>
                                    </v-col>
                                </v-row>
                                <v-divider class="mt-2"></v-divider>
                                <v-row dense>
                                    <v-col cols="12" span="12" class="mt-2 mx-1">
                                        <span>
                                            <v-btn text v-on:click="doCalculate"
                                                :disabled="wizardData.toggled_prices.length === 0"
                                                class="mr-2 buttons-markup"><v-icon medium
                                                    class="mr-1">mdi-cog-outline</v-icon>calculate</v-btn>
                                            <v-btn text v-on:click="doBackUp" class="mr-2 buttons-markup"><v-icon medium
                                                    class="mr-1">mdi-download</v-icon>back-up</v-btn>                                                    
                                            <v-btn text v-on:click="doSave" :disabled="selectionHasErrorOrIsEmpty()"
                                                class="mr-2 buttons-markup"><v-icon medium
                                                    class="mr-1">mdi-database-arrow-right-outline</v-icon>process</v-btn>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </span>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table :headers="getTableHeaders()" :must-sort=true :items="filteredPrices" :disable-pagination=true
                    flat :height="wizardData.wInnerHeight - 415" dense fixed-header item-key="hsnp_datum"
                    no-data-text="No data available" hide-default-footer class="table-markup">

                    <template v-slot:item="price">
                        <tr>
                            <td>
                                <v-layout justify-left>
                                    <span v-if="price.item.hsnp_error">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-avatar size="26" color="white" v-bind="attrs" v-on="on"><v-icon medium
                                                        color="error">mdi-alert-octagon-outline</v-icon></v-avatar>
                                            </template>
                                            <span>{{ price.item.hsnp_error_message }}</span>
                                        </v-tooltip>
                                    </span>
                                    <span v-else-if="price.item.hsnp_warning">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-avatar size="26" color="white" v-bind="attrs" v-on="on"><v-icon medium
                                                        color="warning">mdi-alert-outline</v-icon></v-avatar>
                                            </template>
                                            <span>{{ price.item.hsnp_warning_message }}</span>
                                        </v-tooltip>
                                    </span>
                                    <span v-else>
                                        <v-avatar v-if="price.item.hsnp_updated" size="26" color="white"><v-icon medium
                                                color="success">mdi-check-bold</v-icon></v-avatar>
                                    </span>
                                </v-layout>
                            </td>
                            <td>{{ price.item.hsnp_datum_day }}</td>
                            <td>{{ $moment(price.item.hsnp_datum_sort).format("DD-MM-YYYY") }}</td>
                            <td><span v-if="price.item.hsnp_priority!==0"><v-avatar :size="18" style="border: solid 1px red; margin-right: 5px;"><v-icon color="red" small>mdi-parking</v-icon></v-avatar></span></td>
                            <td align="right">{{ price.item.hsnp_inkoop_display }}</td>
                            <td align="right">
                                <span v-if="price.item.hsnp_inkoop_new_error" class="error-markup">{{
                                    price.item.hsnp_inkoop_new_display }}</span>
                                <span v-else class="correct-markup">{{ price.item.hsnp_inkoop_new_display }}</span>
                            </td>
                            <td align="right">{{ price.item.hsnp_verkoop_display }}</td>
                            <td align="right">
                                <span v-if="price.item.hsnp_verkoop_new_error" class="error-markup">{{
                                    price.item.hsnp_verkoop_new_display }}</span>
                                <span v-else class="correct-markup">{{ price.item.hsnp_verkoop_new_display }}</span>
                            </td>
                            <td align="right">{{ price.item.hsnp_margin_display }}%</td>
                            <td align="right">
                                <span v-if="price.item.hsnp_margin_new_display !== '' && price.item.hsnp_margin_state === 0"
                                    class="correct-markup">{{ price.item.hsnp_margin_new_display }}%</span>
                                <span v-if="price.item.hsnp_margin_new_display !== '' && price.item.hsnp_margin_state === 1"
                                    class="warning-markup">{{ price.item.hsnp_margin_new_display }}%</span>
                                <span v-if="price.item.hsnp_margin_new_display !== '' && price.item.hsnp_margin_state === 2"
                                    class="error-markup">{{ price.item.hsnp_margin_new_display }}%</span>
                                <span
                                    v-else-if="price.item.hsnp_margin_new_display !== '' && price.item.hsnp_margin_state === 3">{{
                                        price.item.hsnp_margin_new_display }}%</span>
                            </td>
                            <td>{{ price.item.hsnp_van }}</td>
                            <td class="correct-markup">{{ price.item.hsnp_van_new }}</td>
                            <td>{{ price.item.hsnp_tm }}</td>
                            <td class="correct-markup">{{ price.item.hsnp_tm_new }}</td>
                            <td align="center">{{ price.item.hsnp_min_aant_nacht_display }}</td>
                            <td class="correct-markup" align="center">{{ price.item.hsnp_min_aant_nacht_new_display }}</td>
                            <td align="right">{{ price.item.hsnp_min_inkoop_display }}</td>
                            <td align="right">
                                <span v-if="price.item.hsnp_min_inkoop_new_error" class="error-markup">{{
                                    price.item.hsnp_min_inkoop_new_display }}</span>
                                <span v-else class="correct-markup">{{ price.item.hsnp_min_inkoop_new_display }}</span>
                            </td>
                            <td align="center">{{ price.item.hsnp_planning_display }}</td>
                            <td class="correct-markup" align="center">{{ price.item.hsnp_planning_new_display }}</td>
                            <td align="right">{{ price.item.hsnp_weekprijs_display }}</td>
                            <td class="correct-markup" align="right">{{ price.item.hsnp_weekprijs_new_display }}</td>
                            <td align="center">{{ price.item.hsnp_schoonmaak_display }}</td>
                            <td class="correct-markup" align="center">{{ price.item.hsnp_schoonmaak_new_display }}</td>
                        </tr>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

    </div>
</template>

<script>

export default {
    props: {
        wizardData: Object,
        number_hsnp_selected: Number
    },
    data() {
        return {
            backupData: {},
            backupPrices: [],
            stat_filter: [{ code: "no_filter", name: "All" }, { code: "warning", name: "Warnings" }, { code: "error", name: "Errors" }, { code: "ready", name: "Ready" }],
        }
    },
    computed: {
        filteredPrices: function () {
            return this.wizardData.new_prices.filter((price) => {
                switch (this.wizardData.filter) {
                    case "warning":
                        return (price.hsnp_warning && !price.hsnp_error);
                    case "error":
                        return (price.hsnp_error);
                    case "ready":
                        return (!price.hsnp_error && price.hsnp_updated);
                    default:
                        return true;
                }
            });
        }
    },
    methods: {
        doCalculate() {
            this.calculateData();
        },
        doSave() {
            this.saveData();
        },
        selectionIsReadyWrapper() {
            const x = this.selectionHasErrorOrIsEmpty();
            console.log(x);
            return x;
        },
        selectionHasErrorOrIsEmpty() {
            return (!!this.filteredPrices.find(el => el.hsnp_error) || this.filteredPrices.length === 0 || !(this.filteredPrices.find(el => el.hsnp_updated))) ? true : false;
        },
        preparePrices() {
            this.backupData = {};
            this.backupPrices = [];
            this.filteredPrices.forEach(el => (!el.hsnp_error && el.hsnp_updated) ? this.backupPrices.push(el) : false);
            this.backupData.backup = 'hsnp';
            this.backupData.hspt = this.wizardData.hspt;
            this.backupData.prices = this.backupPrices;
        },
        doBackUp() {
            this.preparePrices();
            try {
                if (this.backupData.prices.length !== 0) {
                    let fileContent = `${JSON.stringify(this.backupData)}`;
                    let fileBlob = new Blob([fileContent], { type: 'text/plain' });
                    let temp = document.createElement('a');
                    temp.download = `hsnp-${this.backupData.hspt.accommodation}-${this.backupData.hspt.hspt_nr}-${new Date().toISOString()}.json`;
                    temp.href = window.URL.createObjectURL(fileBlob);
                    temp.click();
                }
                else {
                    let message = new Object();
                    message.clear = false;
                    message.type = 'warning';
                    message.caption = 'Warning';
                    message.message = 'Backup would not have any data';
                    this.$emit('showMessage', message);
                }
            } catch (err) {
                this.$emit('showMessage', this.createErrorMessage(err.message));
            }
        },
        createErrorMessage(text) {
            let message = new Object();
            message.clear = false;
            message.type = 'error';
            message.caption = 'Error';
            message.message = text;
            return message;
        },
        getTableHeaders() {
            return [
                { text: "", value: "hsnp_icons", sortable: false, width: "1%" },
                { text: "", value: "hsnp_datum_day", sortable: false, width: "1%" },
                { text: "Datum", value: "hsnp_datum_sort", sortable: false, width: "6%" },
                { text: "", value: "hsnp_priority", sortable: false, width: "1%" },
                { text: "Purchase", align: "end", sortable: false, value: "hsnp_inkoop_display" },
                { text: "New", align: "end", sortable: false, value: "hsnp_inkoop_new_display" },
                { text: "Sales", align: "end", sortable: false, value: "hsnp_verkoop_display" },
                { text: "New", align: "end", sortable: false, value: "hsnp_verkoop_new_display" },
                { text: "Margin", align: "end", sortable: false, value: "hsnp_margin_display" },
                { text: "New", align: "end", sortable: false, value: "hsnp_margin_new_display" },
                { text: "Arrival", value: "hsnp_van", sortable: false },
                { text: "New", value: "hsnp_van_new", sortable: false },
                { text: "Departure", value: "hsnp_tm", sortable: false },
                { text: "New", value: "hsnp_tm_new", sortable: false },
                { text: "Min nights", align: "center", value: "hsnp_min_aant_nacht_display", sortable: false },
                { text: "New", align: "center", value: "hsnp_min_aant_nacht_new_display", sortable: false },
                { text: "Min. purchase", align: "end", sortable: false, value: "hsnp_min_inkoop_display" },
                { text: "New", align: "end", sortable: false, value: "hsnp_min_inkoop_new_display" },
                { text: "Plan", align: "center", value: "hsnp_planning_display", sortable: false },
                { text: "New", align: "center", value: "hsnp_planning_new_display", sortable: false },
                { text: "Week price", align: "end", value: "hsnp_weekprijs_display", sortable: false },
                { text: "New", align: "end", value: "hsnp_weekprijs_new_display", sortable: false },
                { text: "Clean", align: "center", value: "hsnp_schoonmaak_display", sortable: false },
                { text: "New", align: "center", value: "hsnp_schoonmaak_new_display", sortable: false },
            ];
        },
        calculateData() {
            this.$axios
                .post("ares/json/ares/huis/hspt/hsnp/calculateNewHsnpv3.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "processData"
                    },
                    processData: this.wizardData,
                })
                .then(res => {
                    if (res.data.error) {
                        this.$emit('showMessage', this.createErrorMessage(res.data.error.message));
                    } else {
                        this.wizardData.new_prices = res.data.processData.new_prices;
                        this.wizardData.warning = res.data.processData.summary.warning;
                        this.wizardData.error = res.data.processData.summary.error;
                        this.wizardData.updated = res.data.processData.summary.updated;
                        this.wizardData.correct = res.data.processData.summary.correct;
                        console.log(this.wizardData.new_prices)
                    }
                })
        },
        getUUID(){
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        },        
        generateStorageEvent(target) {
            localStorage.setItem(target, this.getUUID());
        },
        saveData() {

            this.preparePrices();

            this.$axios
                .post("ares/json/ares/huis/hspt/hsnp/updateMultipleHsnpv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "processData"
                    },
                    processData: this.backupData,
                })
                .then(res => {
                    if (res.data.error) {
                        this.$emit('showMessage', this.createErrorMessage(res.data.error.message));
                    } else {
                        
                        // refresh parent in other tab
                        this.generateStorageEvent('reload_hsnp');

                        let message = new Object();
                        message.clear = true;
                        message.type = 'info';
                        message.caption = 'Update complete';
                        message.message = `Successfully updated ${res.data.processData.updates} price(s)`;
                        this.$emit('showMessage', message);
                    }
                })
        }
    }
}

</script>

<style scoped>
.avatar-icon {
    border-radius: 200px;
    width: 30px;
    height: 30px;
    border: solid 2px green;
}

.error-markup {
    font-weight: bolder;
    color: red !important;
    ;
}

.correct-markup {
    font-weight: bolder;
    color: limegreen !important;
}

.warning-markup {
    font-weight: bolder;
    color: orange !important;
}

.table-markup {
    font-size: 12px !important;
}

td {
    font-size: 12px !important;
}

.buttons-markup {
    color: grey !important;
}

.card-markup {
    border-style: solid;
    border-width: 2px;
    border-color: lightgrey;
    padding: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
}

.card-summary {
    padding: 10px;
}</style>